import { styled, createGlobalStyle } from 'styled-components'

export const GlobalStyle = createGlobalStyle`

*{
    box-sizing: border-box;
}
body {
    font-family: "Poppins Regular", Open Sans;
    // color: #343a40;
    color: #495057;
}
`
